// const calpak = window.calpak

document.addEventListener("calpak:ready", function (e) {
    const featuresTitles = document.querySelectorAll('.pdp-feature__title');
    featuresTitles.forEach(featuresTitle => featuresTitle.addEventListener('click', (e) => {
        e.preventDefault();

        const target = e.target;
        const prnt = target.closest('.pdp-features');
        const feat = target.closest('.pdp-feature');
        const active = feat.parentNode.querySelector('.pdp-feature--active');

        const index = calpak.getIndex(feat);

        const activeMedia = prnt.querySelector('.pdp-feature__media--active');

        if (activeMedia) {
            activeMedia.classList.remove('pdp-feature__media--active');
            activeMedia.removeAttribute('aria-current');
        }

        prnt.querySelectorAll('.pdp-feature__media')[index].classList.add('pdp-feature__media--active');
        prnt.querySelectorAll('.pdp-feature__media')[index].setAttribute('aria-current', true);

        if (active) {
            active.classList.remove('pdp-feature--active');
            active.querySelector('.pdp-feature__title')?.removeAttribute('aria-current');
        }

        feat.classList.add('pdp-feature--active');
        if (target.classList.contains('pdp-feature__title')) {
            target.setAttribute('aria-current', true);
        } else if (target.parentNode.classList.contains('pdp-feature__title')) {
            target.parentNode.setAttribute('aria-current', true);
        }
    }));
});
